import {Component, Injector} from '@angular/core';
import {PesWizardComponent} from '@pes/ui';

@Component({
    selector: 'lbpa-wizard',
    templateUrl: './lbpa-wizard.component.html'
})
export class LbpaWizardComponent extends PesWizardComponent {


    /**
     * Creates a new PesMessageComponent instance.
     *
     * @param {Injector} injector a reference to the Angular injector.
     */
    constructor(protected injector: Injector) {
        super(injector);
    }

}



// WEBPACK FOOTER //
// ./src/app/component/lbpa-wizard/lbpa-wizard.component.ts